import * as memberService from '../services/emp_search';

export default {
  namespace: 'emp_searchEc',

  state: {},

  effects: {
    *getStoreInfo({ payload: { values } }, { call, put }) {
      const response = yield call(memberService.getStoreInfo, values);
      yield put({
        type: 'save',
        payload: {
          stroeInfo: response?.data,
        },
      });
    },
    //会员详情
    *getMemberDetail({ payload: { values }, callback }, { call, put }) {
      if (values.memberCode && values.memberCode.length === 11) {
        values.memberCode = null;
      }
      const response = yield call(memberService.getMemberDetail, values);
      yield put({
        type: 'save',
        payload: {
          getMemberDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
